import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import SpinnerLoad from '../../moduleComponents/SpinnerLoad';

const ModalAddCategory = ({ onClose, onAdd, submitting }) => {
  const [form, setForm] = useState({ l0: '', l1: '', l2: '', type: 'Out' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.l0 || !form.l1 || !form.l2 || !form.type) return;
    await onAdd({ l0: form.l0, l1: form.l1, l2: form.l2, type: form.type });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-4 md:p-6 rounded-2xl shadow w-80 md:w-96 relative">
        {submitting && (
          <div className="absolute inset-0 flex items-center justify-center z-10">
            <div className="bg-white/90 rounded-xl shadow-lg p-4 border border-gray-200">
              <SpinnerLoad />
            </div>
          </div>
        )}
        <div className="absolute top-2 right-2">
          <button
            onClick={onClose}
            disabled={submitting}
            className="text-gray-500 hover:text-gray-700"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <h2 className="text-lg font-semibold mb-4">Add New Category</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
            <select
              name="type"
              value={form.type}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            >
              <option value="In">Income (In)</option>
              <option value="Out">Expense (Out)</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Level 0</label>
            <input
              type="text"
              name="l0"
              value={form.l0}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
              placeholder="Category L0"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Level 1</label>
            <input
              type="text"
              name="l1"
              value={form.l1}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
              placeholder="Category L1"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Level 2</label>
            <input
              type="text"
              name="l2"
              value={form.l2}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
              placeholder="Category L2"
            />
          </div>
          <div className="flex gap-2 pt-2">
            <button
              type="submit"
              disabled={submitting || !form.l0 || !form.l1 || !form.l2 || !form.type}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg disabled:opacity-50"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalAddCategory;
